import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Store  from './store/store';
import { AzureAD } from 'react-aad-msal';
import { authProvider } from './authProvider';
import './index.css';


ReactDOM.render(
  <AzureAD provider={authProvider} forceLogin={true} reduxStore={Store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </AzureAD>,
  document.getElementById('root')
);
